import React from "react";

const containerCls = "min-h-screen bg-white text-slate-800";
const wrapCls = "max-w-3xl mx-auto px-6 py-12";
const h1Cls = "text-3xl sm:text-4xl font-bold text-slate-900 mb-2";
const effectiveCls = "text-sm text-slate-500 mb-8";
const h2Cls = "text-xl font-semibold text-slate-900 mt-8 mb-3";
const pCls = "text-base leading-relaxed mb-4";
const ulCls = "list-disc pl-6 space-y-1 mb-4 text-base leading-relaxed";
const footerCls = "mt-16 pt-6 border-t border-slate-200 text-sm text-slate-500";

export default function TermsAndConditions() {
  return (
    <div className={containerCls} data-testid="terms-and-conditions-page">
      <div className={wrapCls}>
        <h1 className={h1Cls}>PrepHacker-RN Terms &amp; Conditions</h1>
        <p className={effectiveCls}>Effective Date: July 22, 2026</p>

        <h2 className={h2Cls}>1. Acceptance</h2>
        <p className={pCls}>By using PrepHacker-RN, you agree to these Terms and Conditions.</p>

        <h2 className={h2Cls}>2. Services</h2>
        <p className={pCls}>PrepHacker-RN provides:</p>
        <ul className={ulCls}>
          <li>Nursing examination preparation</li>
          <li>Practice questions</li>
          <li>Mock examinations</li>
          <li>Performance analytics</li>
          <li>AI-assisted learning</li>
          <li>Customer support</li>
        </ul>

        <h2 className={h2Cls}>3. User Accounts</h2>
        <p className={pCls}>Users are responsible for:</p>
        <ul className={ulCls}>
          <li>Providing accurate information</li>
          <li>Keeping account credentials secure</li>
          <li>Maintaining updated contact information</li>
        </ul>

        <h2 className={h2Cls}>4. Subscription</h2>
        <p className={pCls}>PrepHacker-RN may offer:</p>
        <ul className={ulCls}>
          <li>Free trial</li>
          <li>Monthly subscription</li>
          <li>Quarterly subscription</li>
          <li>Annual subscription</li>
        </ul>
        <p className={pCls}>Subscription fees are displayed before purchase.</p>

        <h2 className={h2Cls}>5. Payments</h2>
        <p className={pCls}>Payments are processed through authorized payment providers.</p>
        <p className={pCls}>
          Subscriptions may renew automatically unless cancelled through the applicable app store or payment
          platform.
        </p>

        <h2 className={h2Cls}>6. AI Assistance</h2>
        <p className={pCls}>Our AI provides educational assistance only.</p>
        <p className={pCls}>
          Users should not rely solely on AI responses for examination preparation or professional clinical
          decisions.
        </p>

        <h2 className={h2Cls}>7. Intellectual Property</h2>
        <p className={pCls}>
          All questions, explanations, software, graphics, logos, and content remain the intellectual
          property of PrepHacker-RN unless otherwise stated.
        </p>
        <p className={pCls}>
          Users may not copy, redistribute, or resell platform content without written permission.
        </p>

        <h2 className={h2Cls}>8. Acceptable Use</h2>
        <p className={pCls}>Users agree not to:</p>
        <ul className={ulCls}>
          <li>Share copyrighted content</li>
          <li>Attempt unauthorized access</li>
          <li>Reverse engineer the platform</li>
          <li>Misuse AI services</li>
          <li>Disrupt platform operations</li>
        </ul>

        <h2 className={h2Cls}>9. Termination</h2>
        <p className={pCls}>PrepHacker-RN may suspend or terminate accounts that violate these Terms.</p>

        <h2 className={h2Cls}>10. Limitation of Liability</h2>
        <p className={pCls}>PrepHacker-RN is an educational platform.</p>
        <p className={pCls}>We do not guarantee examination success or employment outcomes.</p>

        <h2 className={h2Cls}>11. Governing Law</h2>
        <p className={pCls}>These Terms shall be governed by the laws of India.</p>

        <div className={footerCls}>
          © PrepHacker-RN · A product of Touch Universe Creative Services Pvt. Ltd. · Contact:{" "}
          <a href="mailto:hello@prephacker.com" className="text-orange-600 hover:underline">
            hello@prephacker.com
          </a>
        </div>
      </div>
    </div>
  );
}
